import React from 'react'
import { Typography } from '@mui/material'

export const AI_CHAT_PROGRESS_PLACEHOLDER = 'Preparing'

/** Shared pulse timeline for the assistant avatar + status label (zero phase offset). */
export const aiAssistantProgressRowPulseSx = {
    animation: 'aiAssistantProgressPulse 1.4s ease-in-out infinite',
    '@keyframes aiAssistantProgressPulse': {
        '0%, 100%': { opacity: 1 },
        '50%': { opacity: 0.35 },
    },
} as const

type Props = {
    label: string
}

export default function ProgressStatusLabel({ label }: Props) {
    const text = label.endsWith('…') || label.endsWith('...') ? label : `${label}…`
    return (
        <Typography variant="body2" noWrap sx={{ minWidth: 0, fontWeight: 500, color: 'text.secondary' }}>
            {text}
        </Typography>
    )
}
